import React from 'react'

import { ARROW_LAYERS_COUNT } from './constants.jsx'

import classNames from 'classnames'
import styles from './UpgradeIcon.scss'

const UpgradeIcon = () => {

    const arrowLayers = Array.from({ length: ARROW_LAYERS_COUNT }, (item, index) => {
        const layerClass = classNames(styles.arrowLayer, styles[`arrowLayer__${index}`])
        return (
            <div className={layerClass} key={`arrowLayer_${index}`}></div>
        )
    })

    return (
        <div className={styles.base}>
            {arrowLayers}
        </div>
    )
}

export default UpgradeIcon


// WEBPACK FOOTER //
// ./components/UpgradeIcon/UpgradeIcon.jsx